const TopPick = () => {
  return (
    <>
      <div className="lc-w-full lc-h-8 lc-px-4 lc-py-2 lc-bg-white lc-absolute lc-top-0 lc-left-0">
        <div className="lc-text-center lc-text-cfa-blue-500 lc-text-sm lc-font-medium lc-leading-none">
          TOP PICK
        </div>
      </div>
    </>
  );
};

export default TopPick;
